import { c as _c } from "react-compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { Image, TextStyled } from '@nike/nike-design-system-components';
import useFetchWebShellProduct from '@nike/shop-apis/web-shell-client/product/use-query';
import { useItemAddedModalComponents } from './ItemAddedModalContext';
import { BoldPriceWrapper, ProductAddedModalContentWrapper, ProductDetailsWrapper, SubtitleSkeleton, TitleSkeleton } from './styles';
import useItemAddedModalStore from "../../../store/item-added-modal/use-store";
var IMAGE_QUERY_PARAMS = '?align=0,1&cropN=0,0,0,0&resMode=sharp&bgc=f5f5f5&fmt=jpg';
var ProductAddedModalContent = function ProductAddedModalContent(t0) {
  var $ = _c(26);
  var customImageURL = t0.customImageURL;
  var _useItemAddedModalCom = useItemAddedModalComponents(),
    ProductSizeComponent = _useItemAddedModalCom.ProductSizeComponent,
    PriceComponent = _useItemAddedModalCom.PriceComponent,
    isMiniBagSubtotalVariant = _useItemAddedModalCom.isMiniBagSubtotalVariant;
  var _useItemAddedModalSto = useItemAddedModalStore(_temp),
    productCode_0 = _useItemAddedModalSto.productCode;
  var t1;
  if ($[0] !== productCode_0) {
    t1 = {
      productCode: productCode_0,
      select: _temp2
    };
    $[0] = productCode_0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  var _useFetchWebShellProd = useFetchWebShellProduct(t1),
    t2 = _useFetchWebShellProd.data,
    isLoading = _useFetchWebShellProd.isLoading;
  var t3;
  if ($[2] !== t2) {
    t3 = t2 === undefined ? {} : t2;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  var _t = t3,
    title_0 = _t.title,
    subtitle_0 = _t.subtitle,
    imageUrl_0 = _t.imageUrl,
    altText = _t.altText;
  var imageSrc = customImageURL || (imageUrl_0 ? "".concat(imageUrl_0).concat(IMAGE_QUERY_PARAMS) : undefined);
  var imageWidth = isMiniBagSubtotalVariant ? "100px" : "154px";
  var t4;
  if ($[4] !== altText || $[5] !== imageSrc) {
    t4 = {
      alt: altText,
      src: imageSrc
    };
    $[4] = altText;
    $[5] = imageSrc;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  var t5;
  if ($[7] !== imageWidth || $[8] !== t4) {
    t5 = /*#__PURE__*/React.createElement(Image, {
      image: t4,
      "data-automation": "cart-item-image",
      width: imageWidth
    });
    $[7] = imageWidth;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  var t6;
  if ($[10] !== isLoading || $[11] !== subtitle_0 || $[12] !== title_0) {
    t6 = isLoading ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TitleSkeleton, null), /*#__PURE__*/React.createElement(SubtitleSkeleton, null)) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(TextStyled, {
      appearance: "body1Strong"
    }, title_0), /*#__PURE__*/React.createElement(TextStyled, {
      color: "secondary"
    }, subtitle_0));
    $[10] = isLoading;
    $[11] = subtitle_0;
    $[12] = title_0;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  var t7;
  if ($[14] !== ProductSizeComponent) {
    t7 = /*#__PURE__*/React.createElement(ProductSizeComponent, null);
    $[14] = ProductSizeComponent;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  var t8;
  if ($[16] !== PriceComponent || $[17] !== isMiniBagSubtotalVariant) {
    t8 = isMiniBagSubtotalVariant ? /*#__PURE__*/React.createElement(BoldPriceWrapper, null, /*#__PURE__*/React.createElement(PriceComponent, null)) : /*#__PURE__*/React.createElement(PriceComponent, null);
    $[16] = PriceComponent;
    $[17] = isMiniBagSubtotalVariant;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  var t9;
  if ($[19] !== t6 || $[20] !== t7 || $[21] !== t8) {
    t9 = /*#__PURE__*/React.createElement(ProductDetailsWrapper, null, t6, t7, t8);
    $[19] = t6;
    $[20] = t7;
    $[21] = t8;
    $[22] = t9;
  } else {
    t9 = $[22];
  }
  var t10;
  if ($[23] !== t5 || $[24] !== t9) {
    t10 = /*#__PURE__*/React.createElement(ProductAddedModalContentWrapper, null, t5, t9);
    $[23] = t5;
    $[24] = t9;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  return t10;
};
ProductAddedModalContent.propTypes = {
  customImageURL: PropTypes.string
};
export default ProductAddedModalContent;
function _temp(t0) {
  var productCode = t0.productCode;
  return {
    productCode: productCode
  };
}
function _temp2(t0) {
  var _productAssets$;
  var title = t0.title,
    subtitle = t0.subtitle,
    imageUrl = t0.imageUrl,
    productAssets = t0.productAssets;
  return {
    title: title,
    subtitle: subtitle,
    imageUrl: imageUrl,
    altText: productAssets === null || productAssets === void 0 || (_productAssets$ = productAssets[0]) === null || _productAssets$ === void 0 ? void 0 : _productAssets$.altText
  };
}